import { featuresData } from '@/mocks/tanhua';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么数百万探花爱好者选择探花系列平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((feat) => (
            <div
              key={feat.id}
              className="p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-accent-200 transition-colors text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className={`${feat.icon} text-2xl text-accent-500`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-2 whitespace-nowrap">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}